const ADDITIONAL_FORMS_FIELDS_PREFIX = 'AdditionalFormsFields'

export const AdditionalFormsFieldsConfig = {
  path: '~/components/genesis/additional-forms-fields',
  global: true,
  prefix: ADDITIONAL_FORMS_FIELDS_PREFIX,
}

export const AdditionalFormsFields = {
  Organization: {
    InformationTab: `${ADDITIONAL_FORMS_FIELDS_PREFIX}OrganizationInformationTab`,
  },
  Workspace: {
    CreationDialog: `${ADDITIONAL_FORMS_FIELDS_PREFIX}WorkspaceCreationDialog`,
    EditionDialog: {
      Tabs: {
        DetailsTabs: `${ADDITIONAL_FORMS_FIELDS_PREFIX}WorkspaceEditionDialogTabsDetailsTab`,
      },
    },
  },
  Profile: `${ADDITIONAL_FORMS_FIELDS_PREFIX}Profile`,
}
